import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface BuddySpeechBalloonProps {
  message: ReactNode;
}

const SPEAKING_BAR_HEIGHTS = [5, 9, 5];

/** Speech balloon with a tail pointing down at Buddy (Figma 8931:166718). */
export function BuddySpeechBalloon({ message }: Readonly<BuddySpeechBalloonProps>) {
  const { t } = useTranslation();

  return (
    <div className="relative flex w-full max-w-[470px] flex-col items-start gap-2.5 rounded-3xl border border-[#e3e4dc] bg-[#edede8] px-7 py-6 dark:border-border dark:bg-card">
      <div className="flex items-center gap-[9px]">
        <span className="text-xs font-medium uppercase tracking-[1.8px] text-[#75786a] dark:text-muted-foreground">
          {t('BUDDY', { defaultValue: 'Buddy' })}
        </span>
        <span aria-hidden className="flex items-center gap-0.5">
          {SPEAKING_BAR_HEIGHTS.map((height, index) => (
            <span
              key={index}
              className="w-0.5 rounded-sm bg-[#838b32]"
              style={{ height }}
            />
          ))}
        </span>
      </div>

      <p className="text-xl leading-[29px] tracking-[-0.4px] text-[#262721] dark:text-foreground">
        {message}
      </p>

      <span
        aria-hidden
        className="absolute -bottom-[10px] left-1/2 size-[18px] -translate-x-1/2 rotate-45 border-b border-r border-[#e3e4dc] bg-[#edede8] dark:border-border dark:bg-card"
      />
    </div>
  );
}
